import { Link } from 'react-router-dom';

import LanguageDropdown from '../common/language-dropdown';

const HeaderSecondary = () => {
  return (
    <header>
      <div className="relative flex items-center justify-between">
        <nav className="flex items-center">
          <figure className="h-8 w-24 md:mr-10 xl:mr-[81px] xl:h-[37px] xl:w-[117px]">
            <Link to="/">
              <img src="assets/logo.png" alt="logo" />
            </Link>
          </figure>
        </nav>
        <div className="hidden items-center gap-x-8 lg:block ">
          <LanguageDropdown />
        </div>
        <div className="block flex items-center gap-x-8 lg:hidden">
          <LanguageDropdown />
        </div>
      </div>
    </header>
  );
};

export default HeaderSecondary;
